import React, { useState, useContext } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';

import { signout } from '../../../../entities/services/auth';
import AdminUserContext from '../../../../contexts/adminUser';

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none'
  },
  flexGrow: {
    flexGrow: 1
  },
  headerLogo: {
    maxHeight: '40px'
  },
  headerText: {
    color: 'white'
  },
  logoContainer: {
    padding: '0 15px',
    marginTop: '5px',
    marginBottom: '5px',
  },
}));

const Topbar = props => {
  const { className, onSidebarOpen, ...rest } = props;
  const history = useHistory();
  const classes = useStyles();

  const [notifications] = useState([]);
  const { adminUser, setAdminUser } = useContext(AdminUserContext);

  const handleLogout = async () => {
    await signout();
    setAdminUser(null);
    history.push('/sing-in')
  }

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Toolbar>
        <RouterLink to="/">
          <div className={classes.logoContainer}>
            <img
              alt="Logo"
              className={classes.headerLogo}
              src="/images/logos/logo_b.png"
            />
          </div>
        </RouterLink>

        <div className={classes.flexGrow} />

        <Hidden mdDown>
          <Typography className={classes.headerText}>{adminUser.username}</Typography>
          <IconButton color="inherit">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <InputIcon/>
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
